@import "~@govbr-ds/core/src/partial/scss/configs/icons";

:host {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  iconify-icon {
    &:focus {
      @include focus;
    }
  }
}

:host([is-inline]) {
  display: inline;
}
